import React, { Component } from 'react'
import Watchlist from './Watchlist'

class Dashboard extends Component {

  componentDidMount = () => {
    window.analytics.page()
  }

  render () {
    return (
      <div>
        <Watchlist />
      </div>
    )
  }
}

export default Dashboard



// WEBPACK FOOTER //
// ./src/components/Dashboard.js